module.exports = __webpack_public_path__ + "static/media/Nguyen_Nang_Hung.4245743f.png";